module.exports = __webpack_public_path__ + "img/law_order.5a92f9c6.png";